import {useState, useEffect} from 'react'
import {useForm} from 'react-hook-form'
import {useParams, useNavigate, Link as RouterLink} from 'react-router-dom'

import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import FormWrapper from '../../shared/FormWrapper'
import Input from '../../shared/Input'
import Loader from '../../shared/Loader'

import {connect} from '../../../state/hooks/tools'
import {createResource, readEndpoint} from '../../../lib/asyncMethods'
import {isEmpty} from '../../../lib/tools'
import {RESET_PASSWORD} from '../../../state/actionTypes'

import './resetPassword.scss'

const ResetPassword = props => {
  const [state, setState] = useState({})
  const [token, setToken] = useState({})
  const methods = useForm()
  const navigate = useNavigate()
  const params = useParams()
  const {errors} = methods.formState

  useEffect(() => {
    props.readEndpoint(`tokens/${params.token}`).then(response => {
      if (response.success)
        setToken(response.data)
      else
        navigate('/not-found')
    })
  }, [])

  const handleSubmit = data => {
    setState(prevState => ({...prevState, loading: true}))

    props.createResource({endpoint: 'passwords/reset-password', attributes: {...data, id: token.id}}).then(response => {
      if (response.success)
        setState(prevState => ({...prevState, message: response.message}))
    }).finally(() => setState(prevState => ({...prevState, loading: false})))
  }

  return (
    <Loader loading={isEmpty(token)}>
      {
        state.message?.length > 0 ? (
          <Stack className='message' component='div'>
            <Typography variant='body1'>{state.message}</Typography>
            <Link to='/auth/sign-in' component={RouterLink} color='primary' underline='hover'>
              <Typography variant='body1' color='secondary'>Sign In</Typography>
            </Link>
          </Stack>
        ) : (
          <Paper elevation={3} component='div' className='reset-password'>
            <Typography variant='h5' gutterBottom>Reset Password</Typography>
            <FormWrapper methods={methods} handleSubmit={handleSubmit}>
              <Input
                error={!!errors.password}
                label='New Password'
                name='password'
                type='password'
                options={{required: 'New Password is required'}}
                helperText={errors.password?.message}
                margin='dense'
              />
              <Input
                error={!!errors.confirmPassword}
                label='Confirm Password'
                name='confirmPassword'
                type='password'
                options={{
                  required: 'Confirm Password is required',
                  validate: value => (value === methods.getValues('password') || 'Passwords do not match')
                }}
                helperText={errors.confirmPassword?.message}
                margin='dense'
              />
              <Button
                disabled={state.loading || isEmpty(token)}
                type='submit'
                variant='contained'
                sx={{color: '#F7F7F7'}}>
                Submit
              </Button>
            </FormWrapper>
          </Paper>
        )
      }
    </Loader>
  )
}

const actionCreators = ({auth}) => ({
  createResource: createResource(auth, RESET_PASSWORD),
  readEndpoint: readEndpoint(auth, RESET_PASSWORD)
})

export default connect(null, actionCreators)(ResetPassword)

